import DeclineModal from './decline-modal.vue';

export default DeclineModal;
